import type { TravelProductId } from './TravelProductToggle.types';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

// Telemetry tracking for Hotels | Cars header toggle interactions (clicks & tooltip dismissals).
export const travelProductToggleTelemetry = createTelemetryObject({
  actions: {
    productToggleClicked: (extraInfo: { from: TravelProductId; to: TravelProductId; eventHandle: string }) => ({
      extraInfo,
      category: 'travel',
      action: 'TravelProductToggleClicked',
    }),
    productToggleTooltipDismissed: (extraInfo: { product: TravelProductId }) => ({
      extraInfo,
      category: 'travel',
      action: 'TravelProductToggleTooltipDismissed',
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(travelProductToggleTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useTravelProductToggleTelemetry };
